import { getKeys } from './getKeys'

export const bodyMapsTranslations = {
  TITLE: 'Body Maps',
  HISTORY: 'History',
  HISTORY_TITLE: 'History - Body Maps',
  DOWNLOAD_PDF: 'Download PDF',
  RETRY: 'Retry',
  LOAD_ERROR: 'Error loading Body Maps',
  HISTORY_LOAD_ERROR: 'Error loading Body Maps history',
  REPORT_NOT_FOUND: 'Body map not found',
  BACK_TO_BODY_MAPS: 'Back to Body Maps',
  EMPTY_NO_LOGS_HEADING: "You haven't added any Body Maps logs yet.",
  EMPTY_NO_LOGS_TEXT: 'Add logs to see them here.',
  EMPTY_NO_RESOLVED_HEADING: "You haven't resolved any Body Maps logs yet.",
  EMPTY_NO_RESOLVED_TEXT: 'Resolved logs will show up here.',
  EMPTY_FILTERED_HEADING: 'No Body Maps logs for the selected dates.',
  EMPTY_FILTERED_TEXT: 'Try a different date range.',
  MARKS_AND_INJURIES: 'Marks and injuries ({{count}})',
  RESOLVED_SUMMARY: '{{resolvedCount}} out of {{totalCount}} resolved.',
  UPDATED_ON: 'Updated {{date}}',
  UPDATED_ON_BY: 'Updated {{date}} • {{name}}',
  BODY_MAPS_SECTION_TITLE: 'Body maps',
  RESOLVED_TAG: 'Resolved',
  COMMENTS_SECTION_TITLE: 'Comments for this mark/injury',
  NO_COMMENTS: 'No comments yet.',
  BODY_MAP_RECORD_TITLE: 'Body map record',
  LOG_REMOVED: 'Log Removed',
  ADDED_ON: 'Added on {{date}}',
  EDITED_BY_ON: 'Edited by {{name}} on {{date}}',
  LOGGED_BY: 'Logged by {{name}}',
  SIDE_LEFT: 'Left',
  SIDE_RIGHT: 'Right'
}

export const bodyMapsConstants = getKeys(bodyMapsTranslations)
